import { TFile } from './Storage.types';
import {
  TFileDataType,
  TFileDataTypeUI,
  TFileUI,
  TMultiOptionTypeMaterialUI,
} from './GeneralTypes';
import { TResidentMoveFormDataProps } from 'pages/private/Tenants/components/ResidentMoveModal/ResidentMoveModal.types';
import { Moment } from 'moment';

export enum EHPVisitationUI {
  REMOTE = 'REMOTE',
  IN_PERSON = 'IN_PERSON',
}
export enum EHPVisitation {
  REMOTE = 'REMOTE',
  IN_PERSON = 'IN_PERSON',
}

export enum EHPDocPacketTypesUI {
  SA = 'SA',
  ESA = 'ESA',
}
export enum EHPDocPacketTypes {
  SA = 'SA',
  ESA = 'ESA',
}

export type TRoiSignature = {
  name: string;
  date: string;
};

export type THPDocFieldUpdateUI = {
  documentPacketId: string;
  value: string;
};

export type THPVisitationUI = {
  websiteAdvertised: string;
  websites?: string[];
};
export type THPVisitation = { websiteAdvertised: boolean; websites?: string[] };

export type THPVisitationGetUI = THPVisitationUI;
export type THPVisitationGet = {
  websiteAdvertised: boolean;
  websites?: { value: string }[];
};

export type THPContactInfoUI = {
  name: string;
  emailAddress?: string;
  phoneNumber?: string;
  faxNumber?: string;
  patientName?: string;
  patientDateOfBirth?: Moment | null;
};
export type THPContactInfo = Omit<THPContactInfoUI, 'patientDateOfBirth'> & {
  patientDateOfBirth?: string | null;
};

export type TNameUpdateUI = THPDocFieldUpdateUI;
export type TNameUpdate = {
  documentPacketId: string;
  hpContactName: string | null;
};

export type TEmailUpdateUI = THPDocFieldUpdateUI;
export type TEmailUpdate = {
  documentPacketId: string;
  hpContactEmail: string | null;
};

export type TPhoneUpdateUI = THPDocFieldUpdateUI;
export type TPhoneUpdate = {
  documentPacketId: string;
  hpContactPhone: string | null;
};

export type TFaxUpdateUI = THPDocFieldUpdateUI;
export type TFaxUpdate = {
  documentPacketId: string;
  hpContactFaxNumber: string | null;
};

export type THPVisitationUpdateUI = {
  documentPacketId: string;
  hpVisitation: THPVisitationUI;
};
export type THPVisitationUpdate = {
  documentPacketId: string;
  hpVisitation: THPVisitation;
};

export type THPLetterUpdateUI = {
  hpDocumentPacketId: string;
  newHpLetters: TFile[];
  removedDocumentsIds?: string[];
};
export type THPLetterUpdate = {
  documentPacketId: string;
  newHpLetters: TFile[];
  removedHpLetterIds?: string[];
};

export type THPFormUpdateUI = {
  tenantId: string;
  hpDocumentPacketId: string;
  newHpForms: TFile[];
  removedHpFormIds?: string[];
};
export type THPFormUpdate = {
  tenantId: string;
  documentPacketId: string;
  newHpForms: TFile[];
  removedHpFormIds?: string[];
};

export type TDocPacketUI = {
  hpDocType: EHPDocPacketTypesUI;
  name: string;
  emailAddress?: string;
  phoneNumber?: string;
  faxNumber?: string;
  websites?: string[];
  hpVisitation: string;
  hpDocPacketLetter?: TFile[];
  patientName: string;
};
export type TDocPacket = {
  hpDocType: EHPDocPacketTypes;
  hpContactInfo: THPContactInfo;
  hpVisitation?: THPVisitation;
  hpDocPacketLetter?: TFile[];
};

export enum EDocPacketStatus {
  NONE = 'NONE',
  VERIFIED = 'VERIFIED',
}
export enum EDocPacketStatusUi {
  NONE = 'NONE',
  VERIFIED = 'VERIFIED',
}

export type TDocPacketGetUI = {
  id: string;
  hpContactInfo: THPContactInfoUI;
  hpDocForms?: TFileDataTypeUI[];
  hpVisitation?: string;
  websites?: string[];
  status: EDocPacketStatusUi;
  hpDocLetters?: TFileDataTypeUI[];
  canEdit: boolean;
  isDeleted: boolean;
  receivedAfterCompletingQuestionnaireOrInterview: boolean;
  roiSignature: TRoiSignature | null;
};
export type TDocPacketGet = {
  hpContactInfo: THPContactInfo;
  hpDocForms?: TFileDataType[];
  hpVisitation?: THPVisitationGet;
  hpDocLetters?: TFileDataType[];
  verificationStatus: EDocPacketStatus;
  modifiable?: boolean;
  hpDocumentPacketId: string;
  isDeleted: boolean;
  receivedAfterCompletingQuestionnaireOrInterview: boolean;
  roiSignature: TRoiSignature | null;
};

export enum ETemplateTypeUI {
  MENTAL_HEALTH_PROFESSIONAL = 'MENTAL_HEALTH_PROFESSIONAL',
  SERVICES_TRAINED = 'SERVICES_TRAINED',
}

export type TAnimalDetailHPVisitationUI = {
  websiteAdvertised: string;
  websites?: string;
};
export type TAnimalDetailHPVisitation = {
  websiteAdvertised: boolean;
  websites?: string[];
};

export type TAnimalDetailAddDocPacketUI = {
  // hpDocType?: EHPDocPacketTypesUI;
  name: string;
  emailAddress?: string;
  phoneNumber?: string;
  faxNumber?: string;
  websites?: string;
  websiteAdvertised: string;
  receivedAfterCompletingQuestionnaireOrInterview: string;
  hpDocPacketLetter?: TFileUI[];
  tenantId?: string;
  patientName?: string;
  patientDateOfBirth?: Moment | null;
};

export type TAnimalDetailAddDocPacket = {
  // hpDocType?: EHPDocPacketTypes;
  hpContactInfo: THPContactInfo;
  hpVisitation?: THPVisitation;
  hpDocPacketLetter?: TFileUI[];
  tenantId?: string;
};

export type TDocPacketInfoDB = {
  hpDocumentPacketId: string;
  receivedAfterCompletingQuestionnaireOrInterview: boolean | null;
  hpVisitation: { websiteAdvertised: boolean; websites?: string[] } | null;
  tenantId?: string;
  roiSignature?: TRoiSignature;
};
export type TDocPacketInfoUI = {
  hpDocumentPacketId: string;
  receivedAfterCompletingQuestionnaireOrInterview: string;
  websiteAdvertised: string;
  websites: string;
  tenantId?: string;
  roiSignature?: TRoiSignature;
};

export type THPDocResponse = {
  preSignedUrl: string;
  docType: ETemplateTypeUI;
};

export type TResidentMoveUi = TResidentMoveFormDataProps & {
  residenceId: string;
};

export type TResidentMove = {
  residenceId: string;
  propertyId: string;
  unitNumber: string;
  startTime?: string;
  endTime?: string;
};

export type TResidenceMoveInfoUI = {
  isPolicyChanging: boolean;
};

export type TResidenceMoveInfo = {
  isPolicyChanging: boolean;
};

export type TOptionTypeDB = {
  id: string;
  name: string;
};
export type TPropertyUI = {
  value: string;
  name: string;
};

export type TPropertyDB = TOptionTypeDB;
